import React from 'react';

const TwitterIcon = (): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fill="none" fillRule="evenodd">
      <g fill="#D6D6D6">
        <path
          d="M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm.852 4.875c-.7.255-1.142.91-1.092 1.628l.017.276-.28-.034c-1.018-.13-1.908-.57-2.663-1.31l-.37-.367-.095.27c-.201.605-.072 1.244.347 1.673.224.237.174.271-.212.13-.135-.045-.252-.08-.263-.062-.04.04.095.553.201.757.146.282.442.559.767.723l.274.13-.325.005c-.313 0-.324.006-.29.125.111.367.553.757 1.046.926l.347.119-.302.18c-.448.26-.974.407-1.5.419-.252.005-.459.028-.459.045 0 .056.683.373 1.08.497 1.192.367 2.608.21 3.67-.418.756-.446 1.512-1.333 1.864-2.192.19-.458.38-1.294.38-1.695 0-.26.018-.294.33-.604.186-.181.36-.379.393-.435.056-.108.05-.108-.235-.012-.476.17-.543.147-.308-.107.173-.18.38-.508.38-.604 0-.017-.084.01-.179.062-.1.056-.324.141-.492.192l-.302.096-.274-.187c-.152-.101-.364-.214-.476-.248-.286-.08-.722-.068-.98.022z"
          transform="translate(-500 -506) translate(260 156) translate(240 16) translate(0 234) translate(0 98) translate(0 2)"
        />
      </g>
    </g>
  </svg>
);

export default TwitterIcon;
